<template>
  <div class="dod-container">
    <dod-view-title :title="'Sms'" />
    <dod-search-input @search="handleSearch" />
    <div class="pagination" v-if="smsList && smsList.meta">
      <pagination-inline
        :dispatchAction="'getDodSmsList'"
        :onPage="smsList.meta.per_page"
        :pageNumber="smsList.meta.current_page"
        :total="smsList.meta.total"
      ></pagination-inline>
    </div>

    <button
      type="button"
      class="addNewButton mb-1"
      style="border-top-right-radius: 8px; border-top-left-radius: 8px"
      data-toggle="modal"
      data-target="#addNewSms"
    >
      Wyślij SMS
    </button>
    <button
      type="button"
      class="addNewButton mb-1"
      data-toggle="modal"
      data-target="#addNewGroupSms"
    >
      Wyślij SMS grupowego
    </button>

    <table
      class="table table-striped"
      v-if="smsList && smsList.data && smsList.data.length > 0"
    >
      <thead>
        <tr style="width: 100%">
          <th scope="col">ID wiadomości</th>
          <th scope="col">Data wysłania</th>
          <th scope="col">Login admina</th>
          <th scope="col">Tel. odbiorcy</th>
          <th scope="col">Wiadomość</th>
          <td scope="col">Grupa odbiorców</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sms in smsList.data" :key="sms.id" style="width: 100%">
          <td>{{ sms.id }}</td>
          <td>
            {{ sms.createdAt ? formatDate(sms.createdAt) : "" }}
          </td>
          <td>{{ sms.admin }}</td>
          <td v-if="sms.type === 'SINGLE'">{{ sms.recipients[0].phone }}</td>
          <td v-else>
            <button
              v-if="sms.recipients && sms.recipients.length > 0"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#dod-list-phone-numbers"
              @click="
                setPhoneNumbersForList(sms.recipients.map((r) => r.phone))
              "
            >
              Lista numerów ({{ sms.recipients.length }})
            </button>
          </td>
          <td>{{ sms.text }}</td>
          <td>{{ translateSmsGroup(sms.type, sms.groupStatus) }}</td>
          <custom-modal title="Lista numerów" :id="'dod-list-phone-numbers'">
            <template #content>
              <span
                v-for="(recipient, index) in phoneNumbersList"
                :key="`${sms.id}_${recipient}_${index}`"
                style="margin-right: 1rem"
                >{{ recipient }}
              </span>
            </template>
          </custom-modal>
        </tr>
      </tbody>
    </table>

    <dod-empty-list v-else />

    <custom-modal id="addNewSms" title="Nowy sms">
            <template #content>
              <div class="">
                <span class="mt-2 mr-2">Prezentowany numer:</span>
                <select v-model="selectedSenderPhoneNumber">
                  <option value="727207020" selected>727207020</option>
                  <option value="606991111">606991111</option>
                  <option value="602743744">602743744</option>
                  <option value="SENIORAPP">SENIORAPP</option>
                </select>
              </div>

              <form class="addNewSmsForm" @submit.prevent="sendSms()">
                <div class="input-container">
                  <input
                    v-model="phoneNumber"
                    id="title"
                    class="form-control"
                    type="number"
                    required
                    minlength="9"
                    maxlength="9"
                    placeholder="Numer telefonu"
                  />
                </div>
                <div class="input-container">
                  <textarea
                    v-model="message"
                    id="message"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="1024"
                    placeholder="Wiadomość..."
                  />
                </div>

                <button
                  class="buttonm btn btn-outline-dark addNewSmsButton"
                  type="submit"
                  :disabled="loading"
                >
                  Wyślij
                </button>
              </form>
            </template>
          </custom-modal>

          <custom-modal id="addNewGroupSms" title="Nowy sms grupowy">
            <template #content>
              <div class="">
                <span class="mt-2 mr-2">Prezentowany numer:</span>
                <select v-model="selectedSenderPhoneNumber">
                  <option value="727207020" selected>727207020</option>
                  <option value="606991111">606991111</option>
                  <option value="602743744">602743744</option>
                  <option value="SENIORAPP">SENIORAPP</option>
                </select>
              </div>

              <form class="addNewSmsForm" @submit.prevent="sendGroupSms()">
                <div class="selectUsersContainer">
                  <input
                    type="checkbox"
                    id="userGroupCheckbox"
                    v-model="toUserGroup"
                  />
                  <label for="userGroupCheckbox"
                    >Wybierz grupę użytkowników</label
                  >
                </div>

                <div v-if="toUserGroup">
                  <div class="row">
                    <div class="col">
                      <label for="">Kto?</label>
                      <select v-model="selectedGroup">
                        <option
                          class="option"
                          :value="option.name"
                          v-for="option in groupOptions"
                          :key="option.name"
                        >
                          {{ option.displayName }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row" v-if="selectedGroup === 'EMPLOYEES'">
                    <div class="col">
                      <label for="">Status opiekunów</label>
                      <select v-model="selectedEmployeesStatus">
                        <option selected value="">Wszystkie</option>
                        <option
                          class="option"
                          :value="option.id"
                          v-for="option in employeeStatuses"
                          :key="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row" v-if="selectedGroup === 'CUSTOMERS'">
                    <div class="col">
                      <label for="">Status podopiecznych</label>
                      <select v-model="selectedCustomersStatus">
                        <option selected value="">Wszystkie</option>
                        <option
                          class="option"
                          :value="option.id"
                          v-for="option in customerStatuses"
                          :key="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div v-if="selectedGroup === 'SELECTED_PHONE_NUMBERS'">
                  <div>
                    <div class="selectUsersContainerDiv">
                      <form @submit.prevent="addOwnNumber">
                        <div>
                          <input id="addNumbersCheckbox" v-model="ownNumber" />
                          <button type="submit" class="btn btn-outline-dark">
                            Dodaj numer
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div
                  v-if="selectedGroup === 'SELECTED_PHONE_NUMBERS'"
                  class="addedNumbers"
                >
                  <div v-for="number in phoneNumbers" :key="number">
                    {{ number }}
                    <i
                      class="fas fa-times removeNumberIcon"
                      @click="deletePhoneNumber(number)"
                    ></i>
                  </div>
                </div>
                <div class="input-container">
                  <textarea
                    v-model="message"
                    id="message"
                    class="form-control"
                    type="text"
                    required
                    minlength="1"
                    maxlength="1024"
                    placeholder="Wiadomość..."
                  />
                </div>

                <button
                  class="buttonm btn btn-outline-dark addNewSmsButton"
                  type="submit"
                  :disabled="loading"
                >
                  Wyślij
                </button>
              </form>
            </template>
          </custom-modal>
  </div>
</template>

<script>
import CustomModal from "../../components/CustomModal.vue";
import DodEmptyList from "../../components/dod/DodEmptyList.vue";
import DodSearchInput from "../../components/dod/DodSearchInput.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import PaginationInline from "../../components/PaginationInline.vue";
import shared from "../../shared";

export default {
  name: "DodSmsList",
  components: {
    DodViewTitle,
    DodSearchInput,
    DodEmptyList,
    CustomModal,
    PaginationInline,
  },

  data() {
    return {
      ownNumber: "",
      toUserGroup: false,
      selectedSenderPhoneNumber: "727207020",
      phoneNumber: "",
      message: "",
      selectedGroup: null,
      phoneNumbers: [],
      loading: false,
      searchValue: "",
      phoneNumbersList: [],
      selectedCustomersStatus: "",
      selectedEmployeesStatus: "",
      groupOptions: [
        {
          name: "ALL",
          displayName: "Wszyscy",
        },
        {
          name: "EMPLOYEES",
          displayName: "Opiekunowie",
        },
        {
          name: "CUSTOMERS",
          displayName: "Podopieczni",
        },
        {
          name: "SELECTED_PHONE_NUMBERS",
          displayName: "Wybrane numery telefonów",
        },
      ],
    };
  },

  watch: {
    selectedGroup() {
      this.selectedCustomersStatus = "";
      this.selectedEmployeesStatus = "";
    },
  },
  async mounted() {
    await this.fetchSmsList(1, 20, this.searchValue);
    await this.$store.dispatch("fetchCustomerStatuses");
    await this.$store.dispatch("fetchEmployeeStatuses");
  },

  destroyed() {},
  methods: {
    setPhoneNumbersForList(phoneNumbers) {
      this.phoneNumbersList = phoneNumbers;
    },
    async fetchSmsList(page, limit, searchValue) {
      await this.$store.dispatch("getDodSmsList", {
        page,
        limit,
        search: searchValue,
      });
    },
    handleSearch(search) {
      this.searchValue = search;
      this.fetchSmsList(
        this.smsList.meta.current_page,
        this.smsList.meta.per_page,
        this.searchValue
      );
    },
    formatDate(date) {
      return shared.formattedDateAsNumbers(date);
    },
    translateSmsGroup(group, groupStatus) {
      if (group === "SELECTED_PHONE_NUMBERS") {
        return "Wybrane numery telefonów";
      } else if (group === "ALL") {
        return "Wszyscy";
      } else if (group === "EMPLOYEES") {
        return `Opiekunowie ${groupStatus ? `(${groupStatus})` : ""}`;
      } else if (group === "CUSTOMERS") {
        return `Podopieczni ${groupStatus ? `(${groupStatus})` : ""}`;
      } else {
        return "Wybrana osoba";
      }
    },
    async sendSms() {
      try {
        this.loading = true;
        const response = await this.$store.dispatch("sendDodSms", {
          senderPhoneNumber: this.selectedSenderPhoneNumber,
          text: this.message,
          type: "SINGLE",
          recipientPhoneNumber: this.phoneNumber,
          recipientsPhoneNumbers: [],
        });
        if (response) {
          this.$notify({
            group: "success",
            text: "Sms został wysłany",
          });
          this.message = "";
          document.getElementById("addNewSms-close").click();
          this.fetchSmsList(1, 20, this.searchValue);
        } else {
          this.$notify({
            group: "error",
            text: "Nie udało się wysłać smsa",
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Nie udało się wysłać smsa",
        });
      } finally {
        this.loading = false;
      }
    },

    async sendGroupSms() {
      try {
        this.loading = true;
        this.$notify({
          group: "success",
          text: "Rozpoczęto wysyłanie smsów",
        });
        const response = await this.$store.dispatch("sendDodSms", {
          senderPhoneNumber: this.selectedSenderPhoneNumber,
          text: this.message,
          type: this.selectedGroup || "SINGLE",
          recipientPhoneNumber: this.phoneNumber,
          recipientsPhoneNumbers: this.phoneNumbers,
          selectedCustomersStatus: this.selectedCustomersStatus,
          selectedEmployeesStatus: this.selectedEmployeesStatus,
        });

        if (response) {
          this.$notify({
            group: "success",
            text: "Sms został wysłany",
          });
          this.message = "";
          document.getElementById("addNewGroupSms-close").click();
          this.fetchSmsList(1, 20, this.searchValue);
        } else {
          this.$notify({
            group: "error",
            text: "Nie udało się wysłać smsa",
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Nie udało się wysłać smsa",
        });
      } finally {
        this.loading = false;
      }
    },

    addOwnNumber() {
      if (this.ownNumber.includes(" ")) {
        this.ownNumber.split(" ").forEach((number) => {
          if (number && number !== "" && !this.phoneNumbers.includes(number)) {
            this.phoneNumbers.push(number);
          }
        });
        this.ownNumber = null;
      } else {
        if (
          this.ownNumber &&
          this.ownNumber !== "" &&
          !this.phoneNumbers.includes(this.ownNumber)
        ) {
          this.phoneNumbers.push(this.ownNumber);
          this.ownNumber = null;
        } else {
          this.ownNumber = null;
        }
      }
    },
    deletePhoneNumber(number) {
      const index = this.phoneNumbers.indexOf(number);
      if (index !== -1) {
        this.phoneNumbers.splice(index, 1);
      }
    },
  },

  computed: {
    smsList() {
      return this.$store.getters.getDodSmsList;
    },
    customerStatuses() {
      return this.$store.getters.getCustomerStatuses;
    },
    employeeStatuses() {
      return this.$store.getters.getEmployeeStatuses;
    },
  },
};
</script>

<style scoped>
.sms-title {
  display: flex;
  align-items: center;
  gap: 4rem;
}
.col {
  display: flex;
  flex-direction: column;
  width: 300px;
}
.row {
  display: flex;
  flex-direction: column;
}

select {
  padding: 5px;
  background: #fff;
  border: none;
  border-radius: 3px;
  color: #090741;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.option {
  background: #fff;
  color: #090741;
}
.addNewSmsButton {
  width: 100%;
  text-align: center;
}
.addNewSmsForm label {
  margin-left: 5px;
}
.selectUsersContainer {
  display: flex;
  width: 200px;
  align-items: center;
  justify-content: center;
}
.selectUsersContainer label {
  padding: 0;
  margin: 0;
  margin-left: 10px;
}
.selectUsersContainerDiv {
  text-align: left;
}
.searchUserPanel {
  display: flex;
  align-items: center;
  width: 100%;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  bottom: 2px;
  pointer-events: none;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.addNewSmsForm table {
  font-size: 9px;
}
.addNewSmsForm thead {
  height: 20px !important;
}
.addedNumbers {
  display: flex;
  flex-wrap: wrap;
}
.addedNumbers div {
  border: 1px solid rgb(173, 172, 172);
  padding: 5px;
  margin: 3px;
  border-radius: 50px;
  position: relative;
  min-width: 90px;
  padding-right: 20px;
}
.removeNumberIcon {
  cursor: pointer;
  position: absolute;
  right: 6px;
  top: 8px;
}
.checkbox-row label {
  margin-top: 5px;
  margin-left: 5px;
  color: #090741;
  font-size: 11px;
}
.checkbox-row {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  margin-top: 15px;
}
</style>
